import CustomerService from '@/services/CustomerService';

// state
const localState = {
  autoLoad: {
    loading: false,
    loader: CustomerService.list,
    emptyMap: {},
  },
  customers: {},
};

// getters
const localGetters = {
};

// mutations
const mutations = {
};

// actions
const actions = {
};

export default {
  state: localState,
  getters: localGetters,
  mutations,
  actions,
};
